module.exports = __webpack_public_path__ + "static/img/indexPost.6ec39b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexPost.png
// module id = MMXJ
// module chunks = 2